import { css } from 'styled-components';
import { getThemeData } from '@hzero-front-ui/core';
var collapseStyle = function collapseStyle(props) {
  var _getThemeData = getThemeData(props, 'common'),
    primary6 = _getThemeData.primary6;
  return css([".ant-collapse.ant-collapse{.ant-collapse-header[aria-expanded='true']{.arrow{color:", ";}}}"], primary6);
};
export default collapseStyle;